import React from "react";
import AreaIndicatorLogbookModal from "./AreaIndicatorLogbookModal";
import AreaLogbookModal from "./AreaLogbookModal";
import PlanLogbookModal from "./PlanLogbookModal";

const getLogbookEntityType = (logbookRelatedEntity) => {
    if (!logbookRelatedEntity) {
        return null;
    }
    const hasFields = (fields) => fields.every(field => field in logbookRelatedEntity);
    if (hasFields(['areaIndicatorId', 'indicatorUUID'])) {
        return 'AREA_INDICATOR';
    }
    if (hasFields(['areaId', 'areaName'])) {
        return 'AREA';
    }
    if (hasFields(['planId', 'planUUID'])) {
        return 'PLAN';
    }
    if (hasFields(['organizationField1', 'organizationField2'])) {
        return 'ORGANIZATION';
    }
    return null;
};

const LogbookModalFactory = ({ open, logbookRelatedEntity, onClose }) => {

    // based on the content of logbookRelatedEntity will return the
    // corresponding logbook modal

    const entityType = getLogbookEntityType(logbookRelatedEntity);
    switch (entityType) {
        case 'AREA_INDICATOR':
            return <AreaIndicatorLogbookModal open={open} logbookRelatedEntity={logbookRelatedEntity} onClose={onClose} />;
        case 'AREA':
            return <AreaLogbookModal open={open} logbookRelatedEntity={logbookRelatedEntity} onClose={onClose} />;
        case 'PLAN':
            return <PlanLogbookModal open={open} logbookRelatedEntity={logbookRelatedEntity} onClose={onClose} />;
        default:
            return null;
    }
    
}

export default LogbookModalFactory;